import useInView from '../hooks/useInView';
import { useLanguage } from '../context/LanguageContext';

const PHILOSOPHY_IMG = 'https://customer-assets.emergentagent.com/job_04606eda-c805-4e3a-af14-63242db4ed24/artifacts/xlmpgbh2_lozi.jpg';

const Philosophy = () => {
  const [ref, inView] = useInView(0.06);
  const { t } = useLanguage();

  return (
    <section id="philosophy" data-testid="philosophy-section" className="bg-cream py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12" ref={ref}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">

          {/* Text — left 5 cols */}
          <div className="lg:col-span-5">
            <div className={`reveal ${inView ? 'visible' : ''}`}>
              <span className="section-label">{t.philosophy.label}</span>
              <div className="line-gold mt-4 mb-8" />
            </div>

            <h2
              className={`reveal reveal-delay-1 font-heading font-light text-obsidian leading-tight mb-7 ${inView ? 'visible' : ''}`}
              style={{ fontSize: 'clamp(1.9rem, 3.5vw, 3rem)' }}
            >
              {t.philosophy.heading[0]}<br />{t.philosophy.heading[1]}
            </h2>

            <div className={`reveal reveal-delay-2 space-y-5 font-body text-winery-text text-base leading-relaxed mb-10 ${inView ? 'visible' : ''}`}>
              <p>{t.philosophy.para1}</p>
              <p>{t.philosophy.para2}</p>
              <p>{t.philosophy.para3}</p>
              <p
                className="text-obsidian"
                style={{ fontFamily: '"Cormorant Garamond", serif', fontSize: '1.1rem', fontStyle: 'italic' }}
              >
                {t.philosophy.closing}
              </p>
            </div>

            <div className={`reveal reveal-delay-3 grid grid-cols-1 gap-4 border-t border-winery-border pt-8 ${inView ? 'visible' : ''}`}>
              {t.philosophy.principles.map((p) => (
                <div key={p.label} className="flex justify-between items-center">
                  <span className="font-body text-xs tracking-widest uppercase text-winery-gold">{p.label}</span>
                  <span className="font-body text-sm text-winery-text">{p.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Image — right 7 cols */}
          <div className={`reveal reveal-delay-2 lg:col-span-7 ${inView ? 'visible' : ''}`}>
            <div className="overflow-hidden" style={{ aspectRatio: '4/5' }}>
              <img
                src={PHILOSOPHY_IMG}
                alt="The vineyard in autumn — Zdravets, Bulgaria"
                className="w-full h-full object-cover parallax-img"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
